import React from 'react';
import { Box, useTheme } from '@mui/material';

const TabPanel = ({ children, value, index, ...other }) => {
  const theme = useTheme();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
      style={{ width: '100%' }}
    >
      {value === index && (
        <Box 
          sx={{ 
            p: { xs: 2, sm: 3 }, 
            transition: 'opacity 300ms', 
            animation: value === index ? 'fadeIn 300ms ease-in-out' : 'none', 
            '@keyframes fadeIn': { 
              from: { opacity: 0 }, 
              to: { opacity: 1 } 
            } 
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
};

export default TabPanel;

